import React, { useState } from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';

const PortalDisclaimer = ({ onAccept }) => {
  return (
    <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f4f6f8',
      padding: 3,
    }}
  >
    <Paper
      elevation={3}
      sx={{
        padding: 4,
        textAlign: 'justify',
        backgroundColor: '#ffffff',
        borderRadius: 2,
      }}
    >
      <Typography variant="h4" component="h3" gutterBottom textAlign="center">
        Disclaimer
      </Typography>

      <Typography variant="body1" paragraph>
        By accessing and using the Blue Aster Capital P.C.C Fund Client Portal (the “Portal”), you hereby
        acknowledge and agree to the following:
      </Typography>

      <Typography variant="h6" component="h6">
       1. Authorized Use:
      </Typography>
      <Typography variant="body1" paragraph>
        You confirm that you are authorized to access the Portal and agree to use it solely for the purposes
        intended by Blue Aster Capital P.C.C Fund (the “Fund”) in accordance with applicable laws, regulations,
        and the terms of service governing the Portal.
      </Typography>

      <Typography variant="h6" component="h6">
        2. Confidentiality:
      </Typography>
      <Typography variant="body1" paragraph>
        You acknowledge that all information made available through the Portal, including but not limited to
        financial data, reports, investment strategies, and portfolio details, is proprietary to the Fund. You
        agree to maintain the confidentiality of such information and to use it strictly for your personal or
        institutional informational purposes as authorized.
      </Typography>

      <Typography variant="h6" component="h6">
        3. Role of the Fund Administrator:
      </Typography>
      <Typography variant="body1" paragraph>
        Yasira Financial Services B.S.C (c), licensed as a Trust Services Provider, and Yasira Funds Services
        W.L.L, licensed as a Fund Administrator (Collectively, the “Fund Administrator”), is responsible for
        calculating, preparing, and managing all financial data, net asset values, portfolio related information
        etc displayed on the Portal. You agree and acknowledge the Fund will not be liable for the accuracy and
        reliability of such information described herein.
      </Typography>

      <Typography variant="h6" component="h6">
        4. Accuracy and Reliance:
      </Typography>
      <Typography variant="body1" paragraph>
        While the Fund and the Fund Administrator endeavor to ensure the accuracy and reliability of the
        information provided through the Portal, you acknowledge that such information is provided on an “as is”
        basis. The Fund makes no representations or warranties, express or implied, regarding the completeness,
        accuracy, or timeliness of the information, and you agree not to rely solely on it for critical investment
        or financial decisions.
      </Typography>

      <Typography variant="h6" component="h6">
       5. Limitation of Liability:
      </Typography>
      <Typography variant="body1" paragraph>
        You acknowledge and agree that the Fund and their respective officers, employees, and affiliates shall
        not be held liable for any direct, indirect, or consequential losses or damages arising from your use of
        the Portal or reliance on any information provided therein.
      </Typography>

      <Typography variant="h6" component="h6">
        6. Acceptance of Terms:
      </Typography>
      <Typography variant="body1" paragraph>
        By proceeding to access the Portal, you signify your acceptance of these terms and conditions. You further
        acknowledge that your continued use of the Portal constitutes your agreement to any updates or amendments
        to these terms as communicated by the Fund from time to time.
      </Typography>

      <button onClick={onAccept} className="btn btn-primary mt-3">I Acknowledge</button>

       <Typography variant="body2" className=" mt-3" paragraph>
        If you do not agree to the above terms, you are advised to refrain from accessing or using the Portal. For
        any questions or concerns regarding this acknowledgment, please reach out at{' '}
        <Link href="mailto:info@blueastercapital.com">info@blueastercapital.com</Link> or your designated
        representative.
      </Typography>
    </Paper>
  </Box>

    
  );
};


export default PortalDisclaimer;